import { useHandleSignInCallback } from '@logto/react'
import { useNavigate } from 'react-router-dom'
import { auth } from '@/services/api'
import { isLogtoEnabled } from '@/providers/LogtoProviderWrapper'
import { POST_AUTH_REDIRECT_KEY } from '@/utils/logtoCallback'

export function CallbackPage() {
  const navigate = useNavigate()

  const { isLoading, error } = useHandleSignInCallback(async () => {
    if (isLogtoEnabled()) {
      try {
        await auth.syncUserinfo()
      } catch (e) {
        console.warn('[Callback] syncUserinfo failed:', e)
      }
    }
    const redirectTo = sessionStorage.getItem(POST_AUTH_REDIRECT_KEY)
    sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY)
    const target = redirectTo && redirectTo.startsWith('/') && !redirectTo.startsWith('//')
      ? redirectTo
      : '/app/prompts'
    navigate(target, { replace: true })
  })

  if (error) {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <div className="auth-header">
            <h1>Sign-in Error</h1>
            <p className="auth-subtitle" style={{ color: 'var(--color-error)' }}>
              {error.message}
            </p>
          </div>
          <button
            className="auth-submit-btn"
            onClick={() => navigate('/', { replace: true })}
          >
            Back to Login
          </button>
        </div>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <div className="auth-header">
            <h1>Signing in...</h1>
            <p className="auth-subtitle">Please wait while we complete your sign-in.</p>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
            <div className="loading-spinner"></div>
          </div>
        </div>
      </div>
    )
  }

  return null
}
